import { render, staticRenderFns } from "./moveToInventory.vue?vue&type=template&id=018d8c59&"
import script from "./moveToInventory.vue?vue&type=script&lang=js&"
export * from "./moveToInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports